import { Configuration } from '@cast/openapi';

export const AXIOS_CONFIGURATION = new Configuration();
